const isEmpty = (x: object | unknown[]) => Object.keys(x).length === 0;

export default isEmpty;
